import axios from "axios";
import Sentry from "./Sentry";
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// No response at all = the user lost connectivity, navigated away or timed out.
// Not actionable, so not reported to Sentry. Any HTTP status (4xx/5xx) is still reported.
export const isTransientNetworkError = (error) =>
  !error?.response &&
  ["ERR_NETWORK", "ECONNABORTED", "ETIMEDOUT"].includes(error?.code);

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers["platform_access"] = "QR";
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!isTransientNetworkError(error)) {
      Sentry.setContext("API Error", {
        url: error.config?.url,
        method: error.config?.method,
        status: error.response?.status,
        requestData: error.config?.data,
        responseData: error.response?.data,
      });

      Sentry.captureException(error);
    }

    return Promise.reject(
      (error.response && error.response.data) || "Something went wrong!"
    );
  }
);

export default axiosInstance;
